import API from 'services/API';
import { formatAddress } from 'utils';

export default function getTaxAuthority(taxCode) {
  return API.request({
    method: 'GET',
    url: `/appointment/taxAuthority?taxCode=${taxCode}`,
    mapper: function (data = null) {
      if (!data) {
        return {};
      } else {
        return {
          address: data.fnsAddress ? formatAddress(data.fnsAddress) : null,
          ...data,
        };
      }
    },
  });
}
